import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// "Mis marcas" (sql/139): varias marcas de contenido dentro de un negocio.
// Pro: hasta 5 · Emprende y Crece: 1 (la principal, que se crea sola).

export const COLORES_MARCA = ['#6D28D9', '#DB2777', '#0D9488', '#D97706', '#2563EB', '#2B1D45'];

export const CATALOGOS = [
  { clave: 'inventario', nombre: 'Productos del inventario', ayuda: 'Para una tienda: el agente usa tus productos con stock.' },
  { clave: 'servicios', nombre: 'Mis servicios', ayuda: 'Para una marca de servicios o software: usa los servicios de esta marca (en Servicios → "¿De qué marca es?").' },
  { clave: 'ambos', nombre: 'Productos y servicios', ayuda: 'Usa tus productos con stock y los servicios de esta marca.' },
  { clave: 'ninguno', nombre: 'Ninguno', ayuda: 'Marca personal o de contenido: sin productos.' },
];

const amigable = (error) => {
  const m = String(error?.message || '');
  if (m.includes('LIMITE_MARCAS')) return new Error('Llegaste al máximo de marcas de tu plan. "Mis marcas" es del plan Pro (hasta 5).');
  if (m.includes('contenido_marcas_nombre_unico') || m.includes('duplicate key')) return new Error('Ya tienes una marca con ese nombre.');
  if (m.includes('MARCA_PRINCIPAL')) return new Error('La marca principal no se puede desactivar.');
  if (m.includes('row-level security') || m.includes('NO_AUTORIZADO')) return new Error('Solo la dueña del negocio puede cambiar las marcas.');
  if (m.includes('violates foreign key')) return new Error('Esta marca ya tiene contenido. Mejor desactívala.');
  return error;
};

// { limite, marcas: [{ id, nombre, color, logo_url, catalogo, principal, activa, orden }] }
export async function misMarcas() {
  const { data, error } = await supabase.rpc('contenido_mis_marcas', { p_negocio: getNegocioId() });
  if (error) throw amigable(error);
  return { limite: Number(data?.limite || 1), marcas: data?.marcas || [] };
}

const limpiar = ({ nombre, color, catalogo }) => {
  const n = String(nombre || '').trim();
  if (n.length < 1 || n.length > 60) throw new Error('Escribe el nombre de la marca (máximo 60 letras).');
  return { nombre: n, color: color || null, catalogo: { tipo: catalogo || 'inventario' } };
};

export async function crearMarca(datos) {
  const { data, error } = await supabase.from('contenido_marcas')
    .insert({ negocio_id: getNegocioId(), ...limpiar(datos) })
    .select('id, nombre, color, logo_url, catalogo, principal, activa, orden').single();
  if (error) throw amigable(error);
  return data;
}

export async function actualizarMarca(id, datos) {
  const cambios = { ...limpiar(datos) };
  if (typeof datos.activa === 'boolean') cambios.activa = datos.activa;
  const { data, error } = await supabase.from('contenido_marcas').update(cambios)
    .eq('id', id).eq('negocio_id', getNegocioId())
    .select('id, nombre, color, logo_url, catalogo, principal, activa, orden').single();
  if (error) throw amigable(error);
  return data;
}
